import React from 'react';
import { Box, Typography } from '@mui/material';
import { palette } from '../../styles/theme';

/**
 * CalendarDayContent - Component to render custom content in calendar days
 *
 * @param {Object} props - Component properties
 * @param {Array} props.values - Array of values to display [{ label, value, color }]
 * @param {String} props.layout - Content layout ('column' | 'row')
 * @param {Object} props.sx - Custom styles
 */
export function CalendarDayContent ({ values = [], layout = 'column', sx = {} }) {
    const hasValues = values?.length > 0;
    if (!hasValues) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: layout,
                gap: '0.31rem',
                width: '100%',
                ...sx
            }}
        >
            {values.map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.15rem',
                        minWidth: 0,
                        overflow: 'hidden',
                    }}
                >
                    {item.label && (
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: '0.77rem',
                                color: palette.disabled[600],
                                fontWeight: 400,
                            }}
                        >
                            {item.label}
                        </Typography>
                    )}
                    <Typography
                        variant="body2"
                        title={item.value}
                        sx={{
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            color: item.color || palette.disabled[900],
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100%',
                        }}
                    >
                        {item.value}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}
